import { inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { DidoDocumentenGallery } from '../components/dido-documenten-gallery/dido-documenten-gallery';
import { DidoGalleryDialogOptions } from '../types/dido-gallery-dialog-options.type';

@Injectable()
export class DidoGalleryService {
    readonly #dialog = inject(MatDialog);

    #dialogRef: MatDialogRef<DidoDocumentenGallery>;

    open(options: DidoGalleryDialogOptions) {
        this.#dialogRef = this.#dialog.open(DidoDocumentenGallery, {
            data: {
                documenten: options.documenten,
                selectedDocument: options.selectedDocument,
                readonly: options.readonly,
                showSideNavigation: options.showSideNavigation,
                showOriButton: options.showOriButton,
                showDeleteButton: options.showDeleteButton
            },
            minWidth: options.minWidth,
            minHeight: options.minHeight,
            id: options.id,
            position: options.position,
            panelClass: options.panelClass
        });
        const backdrop = document.getElementsByClassName('cdk-overlay-dark-backdrop')[0] as HTMLElement;
        if (backdrop) {
            backdrop.style.background = 'rgba(0, 0, 0, 0.850)';
        }
        return this.#dialogRef;
    }
}
